import {Component} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {BtwAcademyHeader} from "./btw-academy-header/btw-academy-header";
import {BtwAcademyInfoCard} from "./models/btw-academy-info-card";
import {BoxItemFlip} from "../../components/display/box-item-flip/box-item-flip";

@Component({
  selector: 'de-btw-academy',
  standalone: true,
  imports: [
    TranslateModule,
    BtwAcademyHeader,
    BoxItemFlip
  ],
  styleUrls: ['./btw-academy.scss'],
  templateUrl: 'de-btw-academy.html'
})
export class DeBtwAcademy {
  protected infoCards: BtwAcademyInfoCard[] = [
    {
      title: 'MiniTrooper Student Learning Program',
      imgClass: 'flip-card-btw-16',
      description: 'MiniTrooper Student Learning Program',
      content: 'Das MiniTrooper Student Learning Program, entwickelt von BMW TechWorks Romania, ist eine Bildungsinitiative zur Förderung und Integration junger Talente im Technologiebereich.\n' +
        'Das Programm ermöglicht es Studierenden, ihr theoretisches Wissen mit praktischer Erfahrung in einem realen Arbeitsumfeld zu verbinden und zu erleben, wie Innovation in einem globalen Technologieunternehmen entsteht.\n' +
        '\n' +
        'Die Studierenden nehmen an einem hybriden Lernprogramm teil – sowohl vor Ort im BMW TechWorks Romania Büro in Cluj-Napoca als auch online – und profitieren von Mentoring, praxisorientierten Aktivitäten und Einblicken in reale Unternehmensprozesse.\n' +
        'MiniTrooper bietet eine umfassende Lernerfahrung und dient als Sprungbrett für eine zukünftige Karriere im Technologiebereich.'
    }, {
      title: 'Science Café – das Labor, in dem Ideen und Forschung lebendig werden',
      imgClass: 'flip-card-btw-10-large',
      description: 'Science Café',
      content: 'Das Science Café ist das Co-Creation-, Forschungs- und Experimentierlabor von BMW TechWorks Romania, offen für Studierende, Lehrende und technologiebegeisterte junge Menschen.\n' +
        'Hier finden Workshops, angewandte Forschungsprojekte, Prototyping, Konzepttests, Hackathons und Innovationsinitiativen zu Themen wie künstliche Intelligenz, Nachhaltigkeit, digitale Mobilität und Softwareentwicklung statt.\n' +
        '\n' +
        'Das Labor kann von Studierenden zu Bildungs- oder Kreativzwecken reserviert werden – auf Anfrage an 👉 office@bmwtechworks.ro.\n' +
        'Ein Raum für Forschung, Zusammenarbeit und Innovation – wo Ideen zu realen Projekten werden.'
    }
  ];
}
